import { Component, OnInit } from "@angular/core";
import { VideoService } from "src/app/shared/component/video/service/video.service";
import { LandingPageService } from "../../service/landing-page.service";


@Component({
  selector: "app-all-products",
  templateUrl: "./all-products.component.html",
  styleUrls: ["./all-products.component.scss"],
})
export class AllProductsComponent implements OnInit {
  public productsList: any;
  public videoUrl = "";
  public posterUrl = "assets/posterImage.png";


  constructor(private videoService: VideoService, private landingPageService: LandingPageService) {}

  public ngOnInit() {
    this.productsList = this.landingPageService.getProductsList();
    this.videoService.openVideoSource$.subscribe((res) => {
      this.videoUrl = res;
    });

    this.landingPageService.emitMarketplaceAPISource$.subscribe(() => {
      this.landingPageService.getProductDetailsList().subscribe((response) => {
        this.productsList = response;
      });
    });
  }
}
